exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".znk_form_item{margin-bottom:5px!important}.el-upload,.el-upload-dragger{width:100%!important}.invoice-text-item{line-height:35px;height:35px!important;border-bottom:1px dashed #66666630}.el-upload-dragger{height:60px}.el-card__header{padding:10px;font-size:14px;font-weight:600}.el-card__body{padding:10px}.text-over{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.el-carousel__container{min-height:600px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6842b2ee","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/dialog/UploadInvoiceDialog.vue
// module id = 252
// module chunks = 0